export const CURRENCIES = [
  {
    name: "Euro",
    code: "EUR",
    flag: "https://twemoji.maxcdn.com/v/latest/svg/1f1ea-1f1fa.svg"
  },
  {
    name: "British Pound",
    code: "GBP",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1ec-1f1e7.png"
  },
  {
    name: "Australian Dollar",
    code: "AUD",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1ed-1f1f2.png"
  },
  {
    name: "New Zealand Dollar",
    code: "NZD",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1f3-1f1ff.png"
  },
  {
    name: "US Dollar",
    code: "USD",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1fa-1f1f8.png"
  },
  {
    name: "Australian Dollar",
    code: "AUD",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1e8-1f1e6.png"
  }
];

export enum CurrenciesSymbols {
  EUR = "€",
  USD = "$",
  GBP = "£",
  AUD = "$",
  NZD = "$"
}
